module.exports = __webpack_public_path__ + "img/1.8299ae6d.jpg";